import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerBills } from 'src/app/model/customerbills.model';
import { Employee } from 'src/app/model/employee.model';
import { ApiService } from 'src/app/services/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-customerbills',
  templateUrl: './customerbills.component.html',
  styleUrls: ['./customerbills.component.scss']
})
export class CustomerBillsComponent implements OnInit {
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';  
 EXCEL_EXTENSION = '.xlsx'; 
displayedColumns: string[] = ['customerId','customerName',
'customerAddress','customerPhone','previousReading', 'currentReading',
  'unitsConsumed','billAmount',
 'prevMonthOutstandingBal','wadarta','amountPaid','totalOutstandingBal','billDate', 'discount','bad_debt','employeeId','billGeneratedFlag','bill_remarks','diff_in_last_month_units_consumed','billPaidDate'];
 displayedHeaderNames: string[] = ['Customer Id','Customer Name',
  'Address','Customer Phone','Prev Reading(A/H)', 'Current Reading(A/D)',
    ' Farqi/Units Consumed','Dalacad/Bill Amount',
   'R. Hre/RH','Wadarta',' Amount Paid(BIXIYAY)','Total Balance(RC)','Bill Date', 'Discount','Bad Debt.','Employee Id','Bill Generated','Bill Remarks','Farqi M3','Bill Paid Date'];
   
dataSource = new MatTableDataSource<CustomerBills>(null);
showPrintTable: boolean = false;
@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
@ViewChild(MatSort, { static: true }) sort: MatSort;
selectedOption=0;
searchValue = '';
  totalData: any;
  searchTriggered: any;
  isLoading: boolean;
  maxDate: string;
  isDateInvalid: boolean = true;
  showError: boolean = false;
constructor(
  @Inject(MAT_DIALOG_DATA) public data: Employee,
  private apiService: ApiService,
  private _snackBar: MatSnackBar) {
    if(data.employeeAction =="all"){
      this.getAllCustomerBillsData();
    }else{
      this.getCustomerBillsData();
    }
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
  
}
customerBills : CustomerBills[] = [];
startDate :any;
endDate:any;

ngOnInit(): void {
}

fetchBills(){
  if(!this.isDateInvalid){
  console.log("Start Date",this.startDate);
  console.log("End Date",this.endDate)

  this.isLoading = true;
  this.apiService.getAllCustomerBillsBasedonDate(this.data,this.startDate,this.endDate)
      .subscribe(data => {
        this.isLoading = false;
        this.customerBills = data.customerBills;
        this.dataSource = new MatTableDataSource<CustomerBills>(data.customerBills);
        this.dataSource.paginator = this.paginator;
        this.totalData = data.totalItems;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (data:CustomerBills, filterValue: string) =>
          (data.customerId.toString() == filterValue) || (data.customerName.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.billGeneratedFlag.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.customerAddress.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.billDate.trim().toLowerCase().indexOf(filterValue) !== -1 );
      });

  
    }else{
      console.log('Cannot fetch bills. Date range is invalid.');
    }
}

validateDates(): void {
  // Missing end date means "single day" — same as start.
  const effectiveEnd = this.endDate || this.startDate;
  if (this.startDate && effectiveEnd) {
    // Check if Start Date is greater than End Date
    this.isDateInvalid = new Date(this.startDate) > new Date(effectiveEnd);
    this.showError = this.isDateInvalid;
  } else {
    this.isDateInvalid = true; // No validation error if one of the dates is null
    this.showError = false;
  }
}

applyFilter(filterValue: string) {
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

getCustomerBillsData() {
  this.isLoading = true;
this.apiService.getCustomerBills(this.data)
    .subscribe(data => {
      this.isLoading = false;
      this.customerBills = data.customerBills;
      this.dataSource = new MatTableDataSource<CustomerBills>(data.customerBills);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = (data:CustomerBills, filterValue: string) =>
        (data.customerId.toString() == filterValue) || (data.customerName.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.billGeneratedFlag.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.customerAddress.trim().toLowerCase().indexOf(filterValue) !== -1 );
    });
}

getAllCustomerBillsData() {
  this.isLoading = true;
  this.apiService.getAllCustomerBills(this.data)
      .subscribe(data => {
        this.isLoading = false;
        this.customerBills = data.customerBills;
        this.dataSource = new MatTableDataSource<CustomerBills>(data.customerBills);
        this.dataSource.paginator = this.paginator;
        this.totalData = data.totalItems;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = (data:CustomerBills, filterValue: string) =>
          (data.customerId.toString() == filterValue) || (data.customerName.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.billGeneratedFlag.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.customerAddress.trim().toLowerCase().indexOf(filterValue) !== -1 ) || (data.billDate.trim().toLowerCase().indexOf(filterValue) !== -1 );
      });
  }
// public exportAsExcelFile(): void {  
//   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.customerBills);  
//   const workbook: XLSX.WorkBook = { Sheets: { 'customer_bill_details': worksheet }, SheetNames: ['customer_bill_details'] };  
//   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });  
//   this.saveAsExcelFile(excelBuffer, "Employee");  
// }  

public exportAsExcelFile(): void {
  // Step 1: Align data with displayedColumns order
  const formattedData = this.customerBills.map(bill => {
    const ordered: any = {};
    this.displayedColumns.forEach(column => {
      ordered[column] = bill[column];
    });
    return ordered;
  });

  // Step 2: Create worksheet with column keys as headers
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData, { header: this.displayedColumns });

  // Step 3: Replace default keys with human-readable headers
  XLSX.utils.sheet_add_aoa(worksheet, [this.displayedHeaderNames], { origin: 'A1' });

  // Step 4: Export workbook
  const workbook: XLSX.WorkBook = {
    Sheets: { 'customer_bill_details': worksheet },
    SheetNames: ['customer_bill_details']
  };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  this.saveAsExcelFile(excelBuffer, "Employee");
}


private saveAsExcelFile(buffer: any, fileName: string): void {  
   const data: Blob = new Blob([buffer], {type: this.EXCEL_TYPE});  
   FileSaver.saveAs(data, fileName +'_'+this.data.employeeId+'_'+"CustomerBills"+'_'+ formatDate(new Date(), 'yyyy/MMM/dd', 'en') + this.EXCEL_EXTENSION); 
}


  // nextpage(event:PageEvent){
  //   this.isLoading = true;
  //   if(this.searchTriggered){event.pageIndex=1;event.previousPageIndex=0};
  //   if(this.data.employeeAction=="all"){
  //     this.apiService.getAllCustomerBills(
  //       this.data, 
  //       event.pageIndex,
  //       event.pageSize,
  //         this.selectedOption,
  //         this.searchValue
  //       )
  //     .subscribe(data => {
  //     this.totalData = data.totalItems;
  //     this.customerBills = data.customerBills;
  //     this.dataSource = new MatTableDataSource<CustomerBills>(data.customerBills);
  //     this.isLoading = false;
  //     this.searchTriggered = false;
  //     });
  //   }else{
  //     this.isLoading=false;
  //   }


  //   }

}
